<template>
  <el-form :inline="true" :model="queryParam" class="mainSearch">
    <el-form-item label="部门名称">
      <el-input v-model="queryParam.name" placeholder="部门名称" />
    </el-form-item>
    <el-form-item label="状态">
      <el-select v-model="queryParam.status" placeholder="部门状态">
        <el-option label="正常" :value="1"/>
        <el-option label="停用" :value="2"/>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-button type="danger" @click="getListDepart">查询</el-button>
      <el-button @click="resetSearch">重置</el-button>
    </el-form-item>
  </el-form>
  <el-row>
    <el-col :span="24">
      <div class="mainTableTop">
        <el-button
          type="danger"
          @click="(dialog = true), doDepartAdd()"
          v-hasPermission="['system:depart:add']"
          >添加部门</el-button>
      </div>
    </el-col>
  </el-row>
  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
  <el-table
    :data="filterTableData"
    v-loading="loadingData"
    class="mainTable"
    default-expand-all
    row-key="departid"
  >
    <el-table-column label="部门名称" prop="name" width="200" />
    <el-table-column label="排序" prop="sort" />
    <el-table-column label="日期" prop="created">
      <template #default="scope">
        <span
          v-text="util.formatDateUnix(scope.row.created, 'yyyy-MM-dd hh:mm')"
        ></span>
      </template>
    </el-table-column>
    <el-table-column label="状态" prop="status">
      <template #default="scope">
        <el-tag
          round
          :type="scope.row.status === 1 ? 'success' : 'danger'"
          disable-transitions
          ><span v-text="util.showCommonStatus(scope.row.status)"></span>
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column label="操作" fixed="right" width="160">
      <template #default="scope">
        <el-link
          type="primary"
          size="small"
          @click="(dialog = true), doDepartEdit(scope.$index, scope.row)"
          v-hasPermission="['system:depart:edit']"
          >编辑</el-link
        >

        <el-popconfirm
          confirm-button-type="danger"
          confirm-button-text="确定"
          cancel-button-text="取消"
          icon-color="#626AEF"
          title="您确定要删除吗？"
          @confirm="doDepartDelete(scope.$index, scope.row)"
        >
          <template #reference>
            <el-link
              size="small"
              type="danger"
              v-hasPermission="['system:depart:delete']"
              >删除</el-link
            >
          </template>
        </el-popconfirm>
      </template>
    </el-table-column>
  </el-table>
  </el-col>
  </el-row>

  <el-row class="mainTableBottom">
    <el-col :span="8"><div>
        <!-- <el-button
          type="danger"
          >添加用户</el-button> -->
      </div></el-col>
    <el-col :span="16">
      <div style="float: right">
        <el-pagination
          :hide-on-single-page="true"
          v-model:page-size="queryParam.pageSize"
          :page-sizes="[10, 15, 20, 30]"
          :background="true"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="changeChangeSize"
          @current-change="changePage"
        />
      </div>
    </el-col>
  </el-row>

  <el-drawer
    ref="drawerRef"
    v-model="dialog"
    :title="title"
    direction="rtl"
    :close-on-click-modal="false"
    size="45%"
    @close="doDepartClose"
  >
    <div class="common-drawer__content">
      <el-form
        ref="departFormRef"
        :model="departForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="父栏目">
          <el-tree-select
            style="width: 100%"
            v-model="departForm.parentid"
            :data="tableData"
            check-strictly
            :render-after-expand="false"
            :props="props"
          >
          </el-tree-select>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input
            v-model.trim="departForm.name"
            placeholder="请输入部门名称"
          />
        </el-form-item>
        <el-form-item label="部门负责人" prop="leader">
          <el-select
            style="width:100%"
            multiple
            filterable
            remote
            reserve-keyword
            placeholder="请输入用户名进行搜索"
            remote-show-suffix
            v-model="defUser"
            :remote-method="getListUser"
            :loading="loading"
            @change="selectUser"
          >
            <el-option
              v-for="item in tableUserData"
              :key="item.value"
              :label="item.label"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="部门电话" prop="tel">
          <el-input v-model.trim="departForm.tel" placeholder="请输入电话" />
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input
            v-model.trim="departForm.email"
            placeholder="请输入邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="desc">
          <el-input
            v-model.trim="departForm.desc"
            type="textarea"
            placeholder="请输入描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="departForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number
            v-model="departForm.sort"
            :min="0"
            :max="100"
            placeholder="排序值"
          />
        </el-form-item>
      </el-form>
      <div class="common-drawer__footer">
        <el-button @click="doDepartClose">关闭</el-button>
        <el-button type="danger" :loading="loading" @click="doDepartSave">{{
          loading ? "提交中 ..." : "提交"
        }}</el-button>
      </div>
    </div>
  </el-drawer>
</template>
    
  <script setup>
import { ref, onMounted, computed } from "vue";
import { ElDrawer, ElTable, ElMessage } from "element-plus";
import { listDepart, saveDepart, deleteDepart } from "@/api/depart";
import { listUser } from "@/api/user";

import util from "@/util/tool.js";

let timer;

let dialog = ref(false);
const loading = ref(false);
const loadingData = ref(true);

const drawerRef = ref(ElDrawer);

const departFormRef = ref();

const defUser = ref();

const total = ref(0);
const pageSize = ref(1000); //每页显示条数

const props = ref({
  checkStrictly: true,
  value: "departid",
  label: "name",
});

let title = ref("添加部门");

//搜索查询
const queryParam = ref({
  pageNo: 1,
  pageSize: pageSize.value,
  name: '',
  status: '',
});

const resetSearch = () => {
  queryParam.value = {
    pageNo: 1,
    pageSize: pageSize.value,
    name: '',
    status: '',
  };
  getListDepart();
};

const departForm = ref({
  departid: null,
  parentid: null,
  name: '',
  desc: '',
  email: '',
  tel: '',
  leader: '',
  leaderid: '',
  sort: 0,
  status: 1,
});

const tableData = ref([]);

const search = ref("");
const filterTableData = computed(() => {
  return tableData.value.filter(
    (data) =>
      !search.value ||
      data.name.toLowerCase().includes(search.value.toLowerCase())
  );
});

const departReset = (departs) => {
  let dataTmp = [];
  departs.forEach((depart) => {
    // console.log(depart);
    depart.departid = depart.departid.toString();
    depart.parentid = depart.parentid.toString();
    dataTmp.push(depart);
    departReset(depart.children);
  });
  return dataTmp;
};

//onMounted方法
onMounted(() => {
  getListDepart();
});

const doDepartAdd = () => {
  title.value = "新增部门";
  defUser.value = []
  tableUserData.value = []
  resetForm();
};

const doDepartEdit = (index, obj) => {
  title.value = "编辑部门";
  // departForm.value = obj;//直接赋值会出问题
  
  if (obj.leader && typeof(obj.leader) !='undefined') {
    let leader = (obj.leader).split(',');
    let leaderid = obj.leaderid.split(',');

    tableUserData.value = []
    let i = 0
    leader.forEach(item => {
        tableUserData.value.push({'label':item,'value':leaderid[i]})
        i++
    });

    defUser.value = tableUserData.value
  } else {
    tableUserData.value = []
    defUser.value = []
  }
  
  departForm.value = {
    departid: obj.departid,
    parentid: obj.parentid ? obj.parentid.toString() : null,
    name: obj.name,
    desc: obj.desc,
    email: obj.email,
    tel: obj.tel,
    leader: obj.leader,
    leaderid: obj.leaderid,
    status: obj.status,
    sort: obj.sort,
  };
};
const doDepartDelete = (index, obj) => {
  deleteDepart(obj).then((res) => {
    if (res.data.code === 1) {
      getListDepart();
    } else {
      ElMessage.error(res.data.msg);
    }
  });
};

const doDepartClose = () => {
  loading.value = false;
  dialog.value = false;
  clearTimeout(timer);
  departFormRef.value.resetFields()
};

const resetForm = () => {
  departForm.value = {
    departid: null,
    parentid: null,
    name: '',
    desc: '',
    email: '',
    tel: '',
    leader: '',
    leaderid: '',
    status: 1,
    sort: 0,
  };
};

const doDepartSave = () => {
  departFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }

    saveDepart(departForm.value).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          getListDepart();
          doDepartClose();
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

//关闭用户表单弹出框
// const doDrawerClose = (done) => {
//   if (loading.value) {
//     return;
//   }
//   ElMessageBox.confirm("您确定要提交表单数据吗？", {
//     distinguishCancelAndClose: true,
//     confirmButtonText: "确定提交",
//     cancelButtonText: "取消",
//   })
//     .then(() => {
//       loading.value = true;
//       timer = setTimeout(() => {
//         done();
//         // 动画关闭需要一定的时间
//         setTimeout(() => {
//           loading.value = false;
//         }, 400);
//       }, 1000);
//     })
//     .catch(() => {
//       // catch error
//     });
// };

//分页
const changePage = (current) => {
  queryParam.value.pageNo = current;
  getListDepart();
};
const changeChangeSize = (size) => {
  pageSize.value = size;
  queryParam.value.pageSize = size;
  getListDepart();
};

//部门表API
const getListDepart = () => {
  listDepart(queryParam.value).then((res) => {
    total.value = res.data.extend.pages.total;
    queryParam.value.pageSize = pageSize.value;
    //重新封装
    tableData.value = departReset(res.data.extend.pages.list);
    loadingData.value = false
  });
};

const selectUser = (users) =>{
    let userid = [];
    let nickname = [];
    users.forEach((user) => {
        userid.push(user.value.toString());
        nickname.push(user.label);
    });
    departForm.value.leader = nickname.join(',')
    departForm.value.leaderid = userid.join(',')
}

const tableUserData = ref([]);
const getListUser = (query) => {
  if (query) {
    loading.value = true;
    setTimeout(() => {
      loading.value = false;
  
      listUser({
        pageNo: 1,
        pageSize: 15,
        nickname: query,
      }).then((res) => {
        tableUserData.value = userReset(res.data.extend.pages.list);
      });
    }, 200);
  } else {
    tableUserData.value = []
  }
};
const userReset = (users) => {
  let dataTmp = [];
  users.forEach((user) => {
    user.value = user.userid.toString();
    user.label = user.nickname;
    dataTmp.push(user);
  });
  return dataTmp;
};

//表单验证规则
const rules = ref({
  name: [
    {
      required: true,
      message: "请输入名称",
      trigger: "blur",
    },
    {
      min: 2,
      max: 30,
      message: "名称长度2到30",
      trigger: "blur",
    },
  ],
  ename: [
    {
      required: true,
      message: "请输入部门",
      trigger: "blur",
    },
    {
      min: 2,
      max: 50,
      message: "部门长度2到50",
      trigger: "blur",
    },
  ],
});
</script>